/**
 * The Culture Roadmap module's permission vocabulary.
 *
 * Two rungs, like the other team roadmaps. People & Events edit — events, who is away, who is
 * joining, which roles are open; everyone else given `view` can see what is happening when
 * without moving it. Every item is editable by any editor: the calendar is a shared record, not
 * a set of personal posts, so there is no per-item ownership check.
 */
import { defineModulePermissions } from '@noissue/authz';

export const CULTURE_ROADMAP = defineModulePermissions({
  id: 'culture-roadmap',
  name: 'Culture Roadmap',
  icon: 'party-popper',
  permissions: {
    view: {
      label: 'View the culture roadmap',
      description: 'See events, holidays, who is away, new joiners and open roles.',
    },
    edit: {
      label: 'Edit the culture roadmap',
      description: 'Add, change and remove events, time away, new joiners and open roles.',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'edit', label: 'Edit', grants: ['view', 'edit'] },
  ],
});
